import {NumberCol, RenderStringCol, Table, ViewOnly} from "../../../../misc/scroller/Table";
import {api} from "../../../../api/API";
import {useAlternative} from "../alternative/Alternative";
import {AnchorCol, JambDepthCol} from "./QuoteOpenings";
import {useProjectId} from "../../shopdrawing/ProjectName";
import {DrawingWallLabel} from "../../../../api/Openings";
import {useIsQuote} from "../QuoteContainer";
import ChevronLeft from "@mui/icons-material/ChevronLeft";
import {Grid, IconButton} from "@mui/material";
import {DrawingWallLabelPopup} from "./DrawingWallLabelPopup";
import {TextEditCell} from "./TextEditCell";
import {getAll} from "../../../logistics/routes/useGetAll";
import {ext} from "../../../../api/Files";
import {yesNo} from "../pricing/PriceRequestPDF";

export function ReviewWallTypeTitle(props: {
    onDone(): void;
}) {
    return (
        <Grid container spacing={1} alignItems="center">
            <Grid item>
                <IconButton onClick={props.onDone}>
                    <ChevronLeft />
                </IconButton>
            </Grid>
            <Grid item>
                Review Wall Types
            </Grid>
        </Grid>
    )
}

export function ReviewWallTypes() {
    const alt = useAlternative();
    const project = useProjectId();
    const isQuote = useIsQuote();

    return (
        <Table<DrawingWallLabel>
            name={"wall-types"}
            fetch={ctx => {
                return getAll(ctx, offset => isQuote ?
                    api.quoteOpenings.listDrawingWallLabels({
                        project: project,
                        alternative: alt,
                        offset,
                    }) :
                    api.openings.listDrawingWallLabels({
                        project: project,
                        offset,
                    }),
                    {
                        useLazy: true,
                    }
                )
            }}
            fetchDeps={[project, alt, isQuote]}
            columns={[
                {
                    name: "Wall Type",
                    editable: {
                        type: "custom",
                        copy: data => data.drawingWallLabel?.toString() || "",
                        paste: (data, value) => {
                            data.drawingWallLabel = value;
                        },
                        render: (props) => {
                            if(!props.row.drawingWallLabel) {
                                return (
                                    <TextEditCell keyName="drawingWallLabel" {...props} />
                                )
                            }

                            return <DrawingWallLabelPopup {...props} />
                        },
                        fileDropAccept: ["application/pdf", "image/*"],
                        fileDropAction: async (files, info) => {
                            const fileObj = await api.files.upload({
                                file: files[0],
                                // use guid naming to prevent collisions
                                name: window.crypto.randomUUID() + ext(files[0].name),
                                convert2pdf: true,
                            });

                            info.update(Object.assign({}, info.row, {
                                drawingWallLabelFile: fileObj.id,
                            }));
                        },
                    },
                    editObj: (dst, src, value: string) => {
                        dst.drawingWallLabel = value;
                        dst.drawingWallLabelFile = undefined;
                    },
                    render: (data, col) => {
                        return data.drawingWallLabel || "";
                    },
                    width: 100,
                },
                {
                    name: "Has Attachment",
                    width: 100,
                    render: data => {
                        return data.drawingWallLabelFile ? "Yes" : "No";
                    }
                },
                RenderStringCol<DrawingWallLabel>("Is FF Profile", d => yesNo(d.frameProfileIsFF)),
                RenderStringCol<DrawingWallLabel>("Frame Construction", d => d.frameConstruction),
                JambDepthCol("Jamb Depth", "jambDepth"),
                AnchorCol<any>({
                    disableQty: true,
                }),
                ViewOnly(NumberCol("Qty", "count")),
                RenderStringCol("-", () => ""),
            ]}
            onChange={v => {
                if(isQuote) return api.quoteOpenings.updateDrawingWallLabel(v)
                return api.openings.updateDrawingWallLabel(v)
            }}
        />
    )
}